// eslint-disable-next-line no-unused-vars
import React from 'react';
import useMobileLayout from 'Hooks/useMobileLayout';
import MessageInputActionsMobile
  from 'Components/UI/ActivityFeed/Shared/HouseholdFeed/MessageInput/MessageInputActionsMobile';
import MessageInputActionsDesktop
  from 'Components/UI/ActivityFeed/Shared/HouseholdFeed/MessageInput/MessageInputActionsDesktop';


const MessageInputActions = (props) => {
  const { showIconButtons } = props;
  const isMobile = useMobileLayout();

  let Component;
  if (isMobile && !showIconButtons) {
    Component = MessageInputActionsMobile;
  } else {
    Component = MessageInputActionsDesktop;
  }
  return <Component {...props} />;
};

export default MessageInputActions;
